import { render } from "./MypageFoodsRankingContent.vue?vue&type=template&id=b278f0aa&scoped=true&ts=true"
import script from "./MypageFoodsRankingContent.vue?vue&type=script&lang=ts"
export * from "./MypageFoodsRankingContent.vue?vue&type=script&lang=ts"

import "./MypageFoodsRankingContent.vue?vue&type=style&index=0&id=b278f0aa&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b278f0aa"]])

export default __exports__